// ハートアンドアロースライダーの初期化
(function() {
  function initHeartArrowSlider() {
    const sliderSections = document.querySelectorAll('.heart-arrow-slider-section');
    
    sliderSections.forEach((section) => {
      const sliderImages = section.querySelector('.heart-arrow-slider-images');
      const imageItems = sliderImages?.querySelectorAll('.heart-arrow-slider-image-item');
      const sliderInput = section.querySelector('.heart-arrow-slider');
      
      if (!sliderInput || !imageItems || imageItems.length === 0) {
        return;
      }

      // 初期表示
      imageItems.forEach((item, i) => {
        if (i === 0) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      // スライダーの変更イベント
      sliderInput.addEventListener('input', function() {
        const value = parseInt(this.value);
        
        // 画像の切り替え
        imageItems.forEach((item, i) => {
          if (i === value) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      });
    });
  }

  // DOMContentLoadedまたは既に読み込み済みの場合
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeartArrowSlider);
  } else {
    initHeartArrowSlider();
  }
})();
